/**
 * Worst-wins hazard → label-background colour for parcel labels on the
 * admin parcels-map. Fuel and Thatch are dominant signals; everything
 * else falls onto a 1→4+ count gradient.
 *
 * Tag matching is case-insensitive substring so common variants ("Fuel
 * load", "Thatched roof", "thatch — heavy") all hit the right bucket.
 */

// Dark red — flammable fuel buildup is the highest-risk signal.
const FUEL_BG = '#8b0000';
// Orange-red — thatched roofing is the next-highest risk.
const THATCH_BG = '#d84315';
// Yellow → orange ramp by count of "other" hazards (1, 2, 3, 4+).
const OTHER_BG = ['#fff9c4', '#ffe082', '#ffb74d', '#fb8c00'];

export const labelBgForHazards = (hazardTags) => {
  if (!hazardTags || hazardTags.length === 0) return null;
  const lc = hazardTags.map((t) => String(t).toLowerCase());
  if (lc.some((t) => t.includes('fuel'))) return FUEL_BG;
  if (lc.some((t) => t.includes('thatch'))) return THATCH_BG;
  const n = Math.min(hazardTags.length, OTHER_BG.length);
  return OTHER_BG[n - 1];
};

// Pick a foreground that stays legible against the chosen background.
// Anything darker than ~mid-orange gets white text.
export const labelFgForBg = (bg) => {
  if (bg === FUEL_BG || bg === THATCH_BG || bg === '#fb8c00') return '#fff';
  return '#000';
};
